/* STYRKR FUEL TOOL — CHARTS LAYER
   ApexCharts (CDN-loaded). Black canvas, mono labels, lime accent.
   No on-chart annotations — full event detail is in the timeline + tooltips. */

   (function (window, document) {
    'use strict';
  
    // Read live colour tokens from .ft-app so section settings drive every chart.
    function readVar(name, fallback) {
      var root = document.querySelector('.ftv7-app');
      if (root) {
        var scoped = getComputedStyle(root).getPropertyValue(name).trim();
        if (scoped) return scoped;
      }
      var global = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
      return global || fallback;
    }
    function ftColors() {
      var accent = readVar('--ft-accent', readVar('--styrkr-green', '#4dcdc6'));
      return {
        accent: accent,
        fg:     readVar('--ft-fg', '#ffffff'),
        mute:   readVar('--ft-mute', 'rgba(255, 255, 255, 0.5)'),
        line:   readVar('--ft-line', 'rgba(255, 255, 255, 0.12)'),
        danger: readVar('--ft-status-danger', '#ff7a4a'),
        warn:   readVar('--ft-status-warn', '#f5d76e'),
        chartPrimary:   readVar('--ft-chart-primary', accent),
        chartSecondary: readVar('--ft-chart-secondary', readVar('--ft-fg', '#ffffff'))
      };
    }
    // Recomputed at the start of each render() call so live token changes flow through.
    var FT_COLORS = ftColors();
  
    function baseOptions() {
      return {
        chart: {
          toolbar: { show: false },
          zoom: { enabled: false },
          animations: { enabled: true, easing: 'easeout', speed: 600 },
          background: 'transparent',
          foreColor: FT_COLORS.mute,
          // V7-22: brand font on graphs — Suisse Light (Book=300) replaces monospace.
          fontFamily: '"SuisseIntl-Book", "SuisseIntl-Bold", "SuisseIntl", "Helvetica Neue", Helvetica, Arial, sans-serif',
          // Allow chart to shrink with parent (no fixed pixel width)
          width: '100%',
          parentHeightOffset: 0
        },
        responsive: [{
          breakpoint: 720,
          options: {
            chart: { height: 200 },
            legend: { position: 'bottom', horizontalAlign: 'left', fontSize: '10px' },
            xaxis: { labels: { style: { fontSize: '9px' } }, tickAmount: 4 },
            yaxis: { labels: { style: { fontSize: '9px' } } }
          }
        }],
        grid: {
          borderColor: FT_COLORS.line,
          strokeDashArray: 0,
          padding: { left: 8, right: 8, top: 0, bottom: 0 }
        },
        tooltip: {
          theme: 'dark',
          x: { formatter: function (v) { return formatTime(v); } }
        },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2 },
        xaxis: {
          labels: { style: { colors: FT_COLORS.mute, fontSize: '10px' } },
          axisBorder: { show: false },
          axisTicks: { color: FT_COLORS.line }
        },
        yaxis: {
          labels: { style: { colors: FT_COLORS.mute, fontSize: '10px' } }
        },
        legend: {
          labels: { colors: FT_COLORS.mute },
          fontSize: '11px',
          markers: { width: 8, height: 8, radius: 99 }
        }
      };
    }
  
    function formatTime(min) {
      if (min == null || isNaN(min)) return '';
      var neg = min < 0;
      var abs = Math.abs(min);
      var h = Math.floor(abs / 60);
      var m = Math.round(abs % 60);
      var label = h + ':' + (m < 10 ? '0' + m : m);
      return (neg ? '−' : '') + label;
    }
  
    // Shared x-axis config for time-series charts.
    // Honours plan.targets.preStartMin so pre-race period appears on the axis.
    function timeAxis(plan) {
      var preStart = (plan.targets && plan.targets.preStartMin) || 0;
      return Object.assign({}, baseOptions().xaxis, {
        type: 'numeric',
        min: preStart,
        max: plan.input.durationMin,
        labels: Object.assign({}, baseOptions().xaxis.labels, { formatter: formatTime }),
        tickAmount: 6
      });
    }
  
    // Race-start line annotation, only shown when there's a pre-race window
    function raceStartAnnotation(plan) {
      if (!plan.targets || !plan.targets.isRace) return [];
      return [{
        x: 0,
        strokeDashArray: 0,
        borderColor: FT_COLORS.fg,
        borderWidth: 1,
        label: {
          borderColor: 'transparent',
          orientation: 'horizontal',
          offsetY: -6,
          style: { color: FT_COLORS.mute, background: 'transparent', fontSize: '10px' },
          text: 'race start'
        }
      }];
    }
  
    function waitForApex(cb, attempts) {
      attempts = attempts || 0;
      if (window.ApexCharts) { cb(); return; }
      if (attempts > 50) { console.warn('[fuel-tool] ApexCharts failed to load'); return; }
      setTimeout(function () { waitForApex(cb, attempts + 1); }, 100);
    }
  
    /* ─────────────────────────────────────────────
       1. CARB BALANCE — intake vs oxidation
       Two lines + filled gradient between (in-system carbs).
       The strong line is intake (rises sharply at events).
       The dashed line is oxidation (smooth, capped at gut tier).
       Gap between = banked carbs not yet burnt.
    ───────────────────────────────────────────── */
    function renderCarbBalance(plan) {
      var el = document.getElementById('ft-chart-cumCarbs');
      if (!el) return;
  
      var intake = plan.chart.ticks.map(function (t) { return [t.timeMin, t.cumCarbsIntake]; });
      var oxidation = plan.chart.ticks.map(function (t) { return [t.timeMin, t.cumOxidation]; });
  
      // Cumulative-carb point at each fueling event — for ingestion markers on the chart.
      var ingestionPoints = plan.events.map(function (ev) {
        var carbsAt = 0;
        plan.events.forEach(function (e) { if (e.timeMin <= ev.timeMin) carbsAt += e.carbs; });
        return {
          x: ev.timeMin,
          y: carbsAt,
          family: ev.product.family,
          title: ev.product.shortTitle,
          carbs: ev.carbs
        };
      });
  
      var opts = Object.assign({}, baseOptions(), {
        series: [
          { name: 'Intake', type: 'area', data: intake },
          { name: 'Oxidised (burnt)', type: 'line', data: oxidation }
        ],
        colors: [FT_COLORS.chartPrimary, FT_COLORS.chartSecondary],
        stroke: { curve: ['stepline', 'smooth'], width: [3, 2], dashArray: [0, 4] },
        fill: {
          type: ['gradient', 'solid'],
          gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.0, stops: [0, 100] }
        },
        xaxis: timeAxis(plan),
        yaxis: Object.assign({}, baseOptions().yaxis, {
          labels: Object.assign({}, baseOptions().yaxis.labels, { formatter: function (v) { return Math.round(v) + 'g'; } })
        }),
        annotations: {
          points: ingestionPoints.map(function (p) {
            var family = p.family;
            // Family-specific marker styles — visual key under the chart matches.
            var markerProps =
              family === 'MIX60'    || family === 'MIX90' || family === 'MIX90_CAF' ? { fillColor: FT_COLORS.chartPrimary, strokeColor: FT_COLORS.bg || '#000', size: 5, shape: 'circle' } :
              family === 'GEL50'    || family === 'GEL30_CAF'                       ? { fillColor: FT_COLORS.chartSecondary, strokeColor: FT_COLORS.chartPrimary, size: 5, shape: 'square' } :
              family === 'BAR50'                                                    ? { fillColor: FT_COLORS.warn, strokeColor: '#000', size: 6, shape: 'square' } :
              family === 'SLT+'                                                     ? { fillColor: 'transparent', strokeColor: FT_COLORS.chartPrimary, size: 5, shape: 'circle' } :
                                                                                      { fillColor: FT_COLORS.chartPrimary, size: 4, shape: 'circle' };
            return {
              x: p.x,
              y: p.y,
              marker: Object.assign({}, markerProps, { strokeWidth: 2 }),
              label: {
                borderColor: 'transparent',
                offsetY: -8,
                style: {
                  background: 'transparent',
                  color: FT_COLORS.mute,
                  fontSize: '9px',
                  fontFamily: '"SuisseIntl-Book","SuisseIntl-Bold","SuisseIntl","Helvetica Neue",Helvetica,Arial,sans-serif'
                },
                text: '+' + p.carbs + 'g'
              }
            };
          }),
          xaxis: raceStartAnnotation(plan)
        },
        tooltip: {
          theme: 'dark',
          shared: true,
          x: { formatter: formatTime },
          y: { formatter: function (v) { return Math.round(v) + 'g'; } }
        },
        annotations: { xaxis: raceStartAnnotation(plan) },
        chart: Object.assign({}, baseOptions().chart, { type: 'line', height: 240 })
      });
      new window.ApexCharts(el, opts).render();
    }
  
    /* ─────────────────────────────────────────────
       2. HOURLY CARBS — bar chart with target line
    ───────────────────────────────────────────── */
    function renderHourlyCarbs(plan) {
      var el = document.getElementById('ft-chart-hourlyCarbs');
      if (!el) return;
      var buckets = plan.chart.hourlyCarbs;
      var cats = buckets.map(function (h) { return h.label; });
      var data = buckets.map(function (h) { return h.carbs; });
      var target = plan.targets.carbsGH;
      var ceiling = plan.targets.gutCeilingGH || target;
      // Highlight the PRE bucket (if present) in a quieter tone — it's not bound by per-hour ceiling
      var colors = buckets.map(function (h) { return h.isPre ? FT_COLORS.chartSecondary : FT_COLORS.chartPrimary; });
  
      var opts = Object.assign({}, baseOptions(), {
        series: [{ name: 'Carbs', data: data }],
        colors: [FT_COLORS.accent],
        xaxis: Object.assign({}, baseOptions().xaxis, {
          categories: cats,
          labels: { style: { colors: FT_COLORS.mute, fontSize: '10px' } }
        }),
        yaxis: Object.assign({}, baseOptions().yaxis, {
          labels: Object.assign({}, baseOptions().yaxis.labels, { formatter: function (v) { return Math.round(v) + 'g'; } })
        }),
        annotations: {
          yaxis: [
            {
              y: target,
              borderColor: FT_COLORS.fg,
              borderWidth: 1,
              strokeDashArray: 4,
              label: {
                borderColor: 'transparent',
                offsetX: 0,
                offsetY: -4,
                style: { color: FT_COLORS.mute, background: 'transparent', fontSize: '9px' },
                text: target + ' g/h target',
                position: 'right'
              }
            },
            ceiling > target ? {
              y: ceiling,
              borderColor: FT_COLORS.danger,
              borderWidth: 1,
              strokeDashArray: 2,
              label: {
                borderColor: 'transparent',
                offsetX: 0,
                offsetY: -4,
                style: { color: FT_COLORS.danger, background: 'transparent', fontSize: '9px' },
                text: ceiling + ' g/h ceiling',
                position: 'right'
              }
            } : null
          ].filter(Boolean)
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            columnWidth: '55%',
            distributed: true
          }
        },
        legend: { show: false },
        tooltip: {
          theme: 'dark',
          x: {
            show: true,
            formatter: function (v, opts) {
              if (opts && typeof opts.dataPointIndex === 'number') {
                var b = buckets[opts.dataPointIndex];
                return b.isPre ? 'Pre-race window' : 'Hour ' + b.hour;
              }
              return '';
            }
          },
          y: { formatter: function (v) { return Math.round(v) + 'g carbs'; } }
        },
        chart: Object.assign({}, baseOptions().chart, { type: 'bar', height: 240 })
      });
      // Use distributed colors so PRE bar can be muted vs in-session bars
      opts.colors = colors;
      new window.ApexCharts(el, opts).render();
    }
  
    /* ─────────────────────────────────────────────
       3. FLUID — intake vs sweat loss
    ───────────────────────────────────────────── */
    function renderFluid(plan) {
      var el = document.getElementById('ft-chart-fluid');
      if (!el) return;
      var intake = plan.chart.ticks.map(function (t) { return [t.timeMin, t.cumFluid]; });
      var loss = plan.chart.ticks.map(function (t) { return [t.timeMin, t.lossFluid]; });
      var opts = Object.assign({}, baseOptions(), {
        series: [
          { name: 'Intake', data: intake },
          { name: 'Sweat loss (est.)', data: loss }
        ],
        colors: [FT_COLORS.chartPrimary, FT_COLORS.danger],
        stroke: { curve: 'smooth', width: 2, dashArray: [0, 4] },
        xaxis: timeAxis(plan),
        yaxis: Object.assign({}, baseOptions().yaxis, {
          labels: Object.assign({}, baseOptions().yaxis.labels, { formatter: function (v) { return Math.round(v) + ' ml'; } })
        }),
        tooltip: {
          theme: 'dark', shared: true,
          x: { formatter: formatTime },
          y: { formatter: function (v) { return Math.round(v) + ' ml'; } }
        },
        chart: Object.assign({}, baseOptions().chart, { type: 'line', height: 240 })
      });
      new window.ApexCharts(el, opts).render();
    }
  
    /* ─────────────────────────────────────────────
       4. SODIUM — intake vs sweat loss
    ───────────────────────────────────────────── */
    function renderSodium(plan) {
      var el = document.getElementById('ft-chart-sodium');
      if (!el) return;
      var intake = plan.chart.ticks.map(function (t) { return [t.timeMin, t.cumSodium]; });
      var loss = plan.chart.ticks.map(function (t) { return [t.timeMin, t.lossSodium]; });
      var opts = Object.assign({}, baseOptions(), {
        series: [
          { name: 'Intake', data: intake },
          { name: 'Sweat loss (est.)', data: loss }
        ],
        colors: [FT_COLORS.chartPrimary, FT_COLORS.danger],
        stroke: { curve: 'smooth', width: 2, dashArray: [0, 4] },
        xaxis: timeAxis(plan),
        yaxis: Object.assign({}, baseOptions().yaxis, {
          labels: Object.assign({}, baseOptions().yaxis.labels, { formatter: function (v) { return Math.round(v) + ' mg'; } })
        }),
        tooltip: {
          theme: 'dark', shared: true,
          x: { formatter: formatTime },
          y: { formatter: function (v) { return Math.round(v) + ' mg'; } }
        },
        chart: Object.assign({}, baseOptions().chart, { type: 'line', height: 240 })
      });
      new window.ApexCharts(el, opts).render();
    }
  
    /* (Effort curve removed — low signal vs the other physiological models.) */
  
    /* ─────────────────────────────────────────────
       5a. HYDRATION — % body mass loss (ACSM 2007)
       2% line = performance impairment, 4% line = health risk.
    ───────────────────────────────────────────── */
    function renderHydration(plan) {
      var el = document.getElementById('ft-chart-hydration');
      if (!el) return;
      var data = plan.chart.ticks.map(function (t) { return [t.timeMin, +t.hydrationLossPct.toFixed(2)]; });
      var maxLoss = Math.max(2, data.reduce(function (m, p) { return Math.max(m, p[1]); }, 0));
      var opts = Object.assign({}, baseOptions(), {
        series: [{ name: 'Body mass loss', data: data }],
        colors: [FT_COLORS.chartPrimary],
        stroke: { curve: 'smooth', width: 3 },
        xaxis: timeAxis(plan),
        yaxis: {
          min: 0,
          max: Math.max(5, Math.ceil(maxLoss + 1)),
          forceNiceScale: false,
          tickAmount: 5,
          labels: {
            style: { colors: FT_COLORS.mute, fontSize: '10px' },
            formatter: function (v) { return v.toFixed(1) + '%'; }
          }
        },
        annotations: {
          yaxis: [
            {
              y: 2,
              borderColor: FT_COLORS.warn,
              borderWidth: 1,
              strokeDashArray: 4,
              label: { borderColor: 'transparent', offsetY: -4, style: { color: FT_COLORS.warn, background: 'transparent', fontSize: '9px' }, text: '2% performance', position: 'right' }
            },
            {
              y: 4,
              borderColor: FT_COLORS.danger,
              borderWidth: 1,
              strokeDashArray: 4,
              label: { borderColor: 'transparent', offsetY: -4, style: { color: FT_COLORS.danger, background: 'transparent', fontSize: '9px' }, text: '4% health risk', position: 'right' }
            }
          ]
        },
        tooltip: {
          theme: 'dark',
          x: { formatter: formatTime },
          y: { formatter: function (v) { return v.toFixed(2) + '% body mass'; } }
        },
        fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.30, opacityTo: 0.0, stops: [0, 100] } },
        chart: Object.assign({}, baseOptions().chart, { type: 'area', height: 240 })
      });
      new window.ApexCharts(el, opts).render();
    }
  
    /* ─────────────────────────────────────────────
       5b. BONK RISK INDEX (composite)
       0.4·glycogen-spent + 0.3·carb-gap + 0.2·intensity + 0.1·hydration-debt.
       Above 50 = caution, above 70 = bonk zone.
    ───────────────────────────────────────────── */
    function renderBonkRisk(plan) {
      var el = document.getElementById('ft-chart-bonkRisk');
      if (!el) return;
      var data = plan.chart.ticks.map(function (t) { return [t.timeMin, t.bonkRiskPct]; });
      var opts = Object.assign({}, baseOptions(), {
        series: [{ name: 'Bonk risk', data: data }],
        colors: [FT_COLORS.chartPrimary],
        stroke: { curve: 'smooth', width: 3 },
        xaxis: timeAxis(plan),
        yaxis: {
          min: 0,
          max: 100,
          forceNiceScale: false,
          tickAmount: 5,
          labels: {
            style: { colors: FT_COLORS.mute, fontSize: '10px' },
            formatter: function (v) { return Math.round(v); }
          }
        },
        annotations: {
          yaxis: [
            {
              y: 70,
              y2: 100,
              fillColor: FT_COLORS.danger,
              opacity: 0.08,
              label: { borderColor: 'transparent', style: { color: FT_COLORS.danger, background: 'transparent', fontSize: '10px' }, text: 'bonk zone', position: 'left', offsetX: 70 }
            },
            {
              y: 50,
              borderColor: FT_COLORS.warn,
              borderWidth: 1,
              strokeDashArray: 4,
              label: { borderColor: 'transparent', offsetY: -4, style: { color: FT_COLORS.warn, background: 'transparent', fontSize: '9px' }, text: 'caution 50', position: 'right' }
            }
          ]
        },
        tooltip: {
          theme: 'dark',
          x: { formatter: formatTime },
          y: { formatter: function (v) { return Math.round(v) + ' / 100'; } }
        },
        fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.30, opacityTo: 0.0, stops: [0, 100] } },
        chart: Object.assign({}, baseOptions().chart, { type: 'area', height: 240 })
      });
      new window.ApexCharts(el, opts).render();
    }
  
    /* ─────────────────────────────────────────────
       5c. ANAEROBIC RESERVE (simplified estimate)
       Cyclist disciplines only. Visualises depletion of anaerobic work capacity
       based on intensity tier. NOTE: this is a planning-grade heuristic, not a
       full Skiba 2012 W'bal integration — labelled "anaerobic reserve" rather
       than "W'bal" to avoid implying validated lab-grade precision. Adequate
       fueling reduces depletion by up to 50% (Burke & Hawley 2018). */
    function renderWbal(plan) {
      var el = document.getElementById('ft-chart-wbal');
      if (!el) return;
      var data = plan.chart.ticks.map(function (t) { return [t.timeMin, t.wbalPct]; });
      var initialKJ = (plan.meta && plan.meta.wbalInitialKJ) || 20;
      var opts = Object.assign({}, baseOptions(), {
        series: [{ name: "Anaerobic reserve", data: data }],
        colors: [FT_COLORS.chartPrimary],
        stroke: { curve: 'smooth', width: 3 },
        xaxis: timeAxis(plan),
        yaxis: {
          min: 0,
          max: 100,
          forceNiceScale: false,
          tickAmount: 5,
          labels: {
            style: { colors: FT_COLORS.mute, fontSize: '10px' },
            formatter: function (v) { return Math.round(v) + '%'; }
          }
        },
        annotations: {
          yaxis: [{
            y: 30,
            y2: 0,
            fillColor: FT_COLORS.danger,
            opacity: 0.08,
            label: { borderColor: 'transparent', style: { color: FT_COLORS.danger, background: 'transparent', fontSize: '10px' }, text: 'fatigue', position: 'left', offsetX: 60 }
          }]
        },
        tooltip: {
          theme: 'dark',
          x: { formatter: formatTime },
          y: { formatter: function (v) { return Math.round(v) + '% (~' + ((v / 100) * initialKJ).toFixed(1) + ' kJ remaining)'; } }
        },
        fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.30, opacityTo: 0.0, stops: [0, 100] } },
        chart: Object.assign({}, baseOptions().chart, { type: 'area', height: 240 })
      });
      new window.ApexCharts(el, opts).render();
    }
  
    /* ─────────────────────────────────────────────
       6. GLYCOGEN DEPLETION — % muscle store remaining
       Lower = closer to bonk. External carb intake slows depletion.
    ───────────────────────────────────────────── */
    function renderGlycogen(plan) {
      var el = document.getElementById('ft-chart-glycogen');
      if (!el) return;
      var data = plan.chart.ticks.map(function (t) { return [t.timeMin, t.glycogenPct]; });
      var opts = Object.assign({}, baseOptions(), {
        series: [{ name: 'Glycogen remaining', data: data }],
        colors: [FT_COLORS.chartPrimary],
        stroke: { curve: 'smooth', width: 3 },
        xaxis: timeAxis(plan),
        yaxis: Object.assign({}, baseOptions().yaxis, {
          min: 0, max: 100,
          labels: Object.assign({}, baseOptions().yaxis.labels, { formatter: function (v) { return Math.round(v) + '%'; } })
        }),
        annotations: {
          yaxis: [{
            y: 25,
            y2: 0,
            fillColor: FT_COLORS.danger,
            opacity: 0.08,
            label: {
              borderColor: 'transparent',
              style: { color: FT_COLORS.danger, background: 'transparent', fontSize: '10px' },
              text: 'bonk risk', position: 'left', offsetX: 80
            }
          }]
        },
        tooltip: {
          theme: 'dark',
          x: { formatter: formatTime },
          y: { formatter: function (v) { return v + '%'; } }
        },
        fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.30, opacityTo: 0.0, stops: [0, 100] } },
        chart: Object.assign({}, baseOptions().chart, { type: 'area', height: 240 })
      });
      new window.ApexCharts(el, opts).render();
    }
  
    /* ─────────────────────────────────────────────
       7. CAFFEINE PLASMA — mg in plasma over time
       Each dose adds; exponential decay (5h half-life).
       ISSN performance window: 3-6 mg/kg.
    ───────────────────────────────────────────── */
    function renderCaffeine(plan) {
      var el = document.getElementById('ft-chart-caffeine');
      if (!el) return;
      if (plan.input.caffeine === 'no' || plan.totals.caffeineMg === 0) {
        el.innerHTML = '<div style="height:240px;display:flex;align-items:center;justify-content:center;color:' + FT_COLORS.mute + ';font-family:\'SuisseIntl-Book\',\'SuisseIntl-Bold\',\'Helvetica Neue\',Helvetica,Arial,sans-serif;font-weight:300;text-transform:uppercase;font-size:12px;letter-spacing:0.12em">No caffeine in plan</div>';
        return;
      }
      var data = plan.chart.ticks.map(function (t) { return [t.timeMin, t.cumCaf]; });
      var opts = Object.assign({}, baseOptions(), {
        series: [{ name: 'Plasma caffeine (mg)', data: data }],
        colors: [FT_COLORS.chartPrimary],
        stroke: { curve: 'smooth', width: 3 },
        xaxis: timeAxis(plan),
        yaxis: Object.assign({}, baseOptions().yaxis, {
          labels: Object.assign({}, baseOptions().yaxis.labels, { formatter: function (v) { return Math.round(v) + ' mg'; } })
        }),
        annotations: {
          yaxis: [
            {
              y: 3 * plan.input.weightKg,
              y2: 6 * plan.input.weightKg,
              fillColor: FT_COLORS.accent,
              opacity: 0.06,
              label: {
                borderColor: 'transparent',
                style: { color: FT_COLORS.mute, background: 'transparent', fontSize: '10px' },
                text: 'ISSN performance band', position: 'left', offsetX: 130
              }
            }
          ]
        },
        tooltip: {
          theme: 'dark',
          x: { formatter: formatTime },
          y: { formatter: function (v) { return Math.round(v) + ' mg (' + (v / plan.input.weightKg).toFixed(1) + ' mg/kg)'; } }
        },
        fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.30, opacityTo: 0.0, stops: [0, 100] } },
        chart: Object.assign({}, baseOptions().chart, { type: 'area', height: 240 })
      });
      new window.ApexCharts(el, opts).render();
    }
  
    /* ─────────────────────────────────────────────
       RENDER — split into primary (always visible)
       and secondary (lazy-mounted under the expander)
    ───────────────────────────────────────────── */
    /* ─────────────────────────────────────────────
       6. CARB DEFICIT (SCI-P1-8)
       Target carbs at each point minus actual ingested. Positive (above zero)
       means the athlete is behind schedule — the visual proxy for "you'll bonk
       soon if you don't catch up". Below-zero = comfortably fueled.
       Zone shading: 0-20g = green tolerance, 20-50g = caution, 50+ = bonk pace.
    ───────────────────────────────────────────── */
    function renderCarbDeficit(plan) {
      var el = document.getElementById('ft-chart-carbDeficit');
      if (!el) return;
      var data = plan.chart.ticks.map(function (t) { return [t.timeMin, t.carbDeficit]; });
      var maxDeficit = data.reduce(function (m, p) { return Math.max(m, p[1]); }, 0);
      var yMax = Math.max(50, Math.ceil(maxDeficit / 10) * 10 + 10);
      var opts = Object.assign({}, baseOptions(), {
        series: [{ name: 'Carb deficit', data: data }],
        colors: [FT_COLORS.chartPrimary],
        stroke: { curve: 'smooth', width: 3 },
        xaxis: timeAxis(plan),
        yaxis: {
          min: Math.min(-10, Math.floor(data.reduce(function (m, p) { return Math.min(m, p[1]); }, 0) / 10) * 10),
          max: yMax,
          forceNiceScale: true,
          labels: {
            style: { colors: FT_COLORS.mute, fontSize: '10px' },
            formatter: function (v) { return Math.round(v) + 'g'; }
          }
        },
        annotations: {
          yaxis: [
            // Coloured zone fills (no labels — labels live on the threshold lines below
            // so they can't collapse onto each other when the deficit band is thin).
            { y: 20, y2: 50,   fillColor: FT_COLORS.warn,   opacity: 0.06 },
            { y: 50, y2: yMax, fillColor: FT_COLORS.danger, opacity: 0.08 },
            // Threshold lines with right-anchored labels at distinct y-heights (0 / 20 / 50)
            // — guaranteed vertical separation, no overlap regardless of chart scale.
            { y: 0,  borderColor: FT_COLORS.mute, borderWidth: 1, strokeDashArray: 0,
              label: { borderColor: 'transparent', position: 'right', offsetY: -2,
                style: { color: FT_COLORS.mute, background: 'transparent', fontSize: '9px' }, text: 'on target' } },
            { y: 20, borderColor: FT_COLORS.warn, borderWidth: 1, strokeDashArray: 4,
              label: { borderColor: 'transparent', position: 'right', offsetY: -2,
                style: { color: FT_COLORS.warn, background: 'transparent', fontSize: '9px' }, text: 'caution' } },
            { y: 50, borderColor: FT_COLORS.danger, borderWidth: 1, strokeDashArray: 4,
              label: { borderColor: 'transparent', position: 'right', offsetY: -2,
                style: { color: FT_COLORS.danger, background: 'transparent', fontSize: '9px' }, text: 'bonk pace' } }
          ]
        },
        tooltip: {
          theme: 'dark',
          x: { formatter: formatTime },
          y: { formatter: function (v) { return (v >= 0 ? '+' : '') + Math.round(v) + 'g vs target'; } }
        },
        fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.28, opacityTo: 0.0, stops: [0, 100] } },
        chart: Object.assign({}, baseOptions().chart, { type: 'area', height: 240 })
      });
      new window.ApexCharts(el, opts).render();
    }
  
    function renderPrimary(plan) {
      waitForApex(function () {
        FT_COLORS = ftColors();
        renderCarbBalance(plan);
        renderHydration(plan);
      });
    }
    function renderSecondary(plan) {
      waitForApex(function () {
        FT_COLORS = ftColors();
        renderHourlyCarbs(plan);
        renderCarbDeficit(plan);          // SCI-P1-8
        renderBonkRisk(plan);
        if (plan.meta && plan.meta.isCyclistish) {
          renderWbal(plan);
        }
        renderGlycogen(plan);
        renderCaffeine(plan);
        renderFluid(plan);
        renderSodium(plan);
      });
    }
    function renderAll(plan) {
      renderPrimary(plan);
      renderSecondary(plan);
    }
  
    window.STYRKR_FUEL_V7_CHARTS = {
      render: renderAll,
      renderPrimary: renderPrimary,
      renderSecondary: renderSecondary
    };
  
  })(window, document);
  